import React from 'react';
import { RemoveBackground } from './removeBackground.jsx';

export const wrapImageOverlayer = (Overlayer) => (props) => {
  const { currentElementTool, editingElementId, element } = props;
  const isActive = currentElementTool === 'removeBackground' && editingElementId === element.id;

  return (
    <>
      {isActive ? <RemoveBackground element={element} /> : null}
      <Overlayer {...props} />
    </>
  );
};
